// Automatisch erzeugt von scripts/normalize-blog-links.ts – nicht von Hand bearbeiten.
export const BLOG_SLUGS: Readonly<Record<string, { da?: string; nl?: string }>> = {
  "wege-der-landwirtschaftlichen-direktvermarktung": {
    "da": "veje-til-landbrugsmssig-direkte-afstning",
    "nl": "wegen-van-agrarische-directe-verkoop"
  },
  "einen-secret-packs-automaten-aufstellen": {
    "da": "opstil-en-secret-pack-automat",
    "nl": "een-secret-packs-automaat-plaatsen"
  },
  "selbstgemachtes-verkaufen": {
    "da": "slg-hjemmelavet",
    "nl": "zelfgemaakte-producten-verkopen"
  },
  "gebrauchte-verkaufsautomaten": {
    "da": "brugte-salgsautomater",
    "nl": "gebruikte-verkoopautomaten"
  },
  "alkoholisches-in-automaten-verkaufen": {
    "da": "salg-af-alkohol-i-automater",
    "nl": "alcohol-verkopen-in-automaten"
  },
  "so-kommt-die-marktbox-zu-ihnen": {
    "da": "sdan-kommer-marktboxen-til-dig",
    "nl": "zo-komt-de-marktbox-bij-u"
  },
  "wie-ein-baecker-mit-verkaufsautomaten-die-umsaetze-steigert": {
    "da": "hvordan-en-bager-ger-omstningen-med-salgsautomater",
    "nl": "hoe-een-bakker-met-verkoopautomaten-de-omzet-verhoogt"
  },
  "mit-automaten-geld-verdienen": {
    "da": "tjen-penge-med-automater",
    "nl": "geld-verdienen-met-automaten"
  },
  "einblicke-in-die-produktion-der-marktbox": {
    "da": "indblik-i-produktionen-af-marktboxen",
    "nl": "een-kijkje-in-de-productie-van-de-marktbox"
  },
  "den-eigenen-verkaufsautomaten-bekannt-machen": {
    "da": "gr-din-egen-salgsautomat-kendt",
    "nl": "uw-eigen-verkoopautomaat-bekendmaken"
  },
  "selbstgemachte-lebensmittel-verkaufen-auflagen-und-vorschriften": {
    "da": "salg-af-hjemmelavede-fdevarer-krav-og-regler",
    "nl": "zelfgemaakte-levensmiddelen-verkopen-regels-en-voorschriften"
  },
  "was-macht-smarte-verkaufsautomaten-aus": {
    "da": "hvad-kendetegner-smarte-salgsautomater",
    "nl": "wat-maakt-slimme-verkoopautomaten-bijzonder"
  },
  "einen-getraenkeautomaten-aufstellen": {
    "da": "opstille-en-drikkevareautomat",
    "nl": "een-drankenautomaat-plaatsen"
  },
  "google-unternehmensprofil-fuer-verkaufsautomaten": {
    "da": "google-virksomhedsprofil-til-salgsautomater",
    "nl": "google-bedrijfsprofiel-voor-verkoopautomaten"
  },
  "mit-einem-automaten-kiosk-voll-im-trend": {
    "da": "helt-med-p-trenden-med-en-automatkiosk",
    "nl": "met-een-automatenkiosk-helemaal-on-trend"
  },
  "braucht-mein-verkaufsautomat-eine-tse": {
    "da": "har-min-salgsautomat-brug-for-en-tse",
    "nl": "heeft-mijn-verkoopautomaat-een-tse-nodig"
  },
  "einen-selbstbedienungsschrank-eroeffnen": {
    "da": "bn-et-selvbetjeningsskab",
    "nl": "een-zelfbedieningskast-openen"
  },
  "alles-zur-automatenversicherung": {
    "da": "alt-om-automatforsikring",
    "nl": "alles-over-de-automatenverzekering"
  },
  "laufende-kosten-von-automaten": {
    "da": "lbende-omkostninger-for-automater",
    "nl": "lopende-kosten-van-automaten"
  },
  "verkaufsautomat-fuer-backwaren": {
    "da": "salgsautomat-til-bagvrk",
    "nl": "verkoopautomaat-voor-bakkerijproducten"
  },
  "bargeldlos-zahlen-am-automaten": {
    "da": "kontantls-betaling-ved-automaten",
    "nl": "cashless-betalen-bij-de-automaat"
  },
  "verkaufsautomaten-ihr-247-tankstellen-shop": {
    "da": "salgsautomater-din-247-tankstationsbutik",
    "nl": "verkoopautomaten-uw-247-tankstationshop"
  },
  "warum-sich-ein-honigautomat-lohnt": {
    "da": "hvorfor-en-honningautomat-kan-betale-sig",
    "nl": "waarom-een-honingautomaat-de-moeite-waard-is"
  },
  "simple-direktvermarktung-dank-weinautomat": {
    "da": "enkelt-direkte-salg-takket-vre-vinautomat",
    "nl": "eenvoudige-directe-verkoop-dankzij-de-wijnautomaat"
  },
  "ein-eigener-verkaufsautomat-kaufen-oder-mieten": {
    "da": "din-egen-salgsautomat-kbe-eller-leje",
    "nl": "een-eigen-verkoopautomaat-kopen-of-huren"
  },
  "verkaufsautomat-fuer-baeckereien": {
    "da": "salgsautomat-til-bagerier",
    "nl": "verkoopautomaat-voor-bakkerijen"
  },
  "umsatz-steigern-in-der-baeckerei": {
    "da": "g-omstningen-i-bageriet",
    "nl": "omzet-verhogen-in-de-bakkerij"
  },
  "einen-hofladen-automaten-aufstellen": {
    "da": "opstil-en-grdbutik-automat",
    "nl": "een-boerderijautomaat-plaatsen"
  },
  "die-vorteile-von-klappenautomaten": {
    "da": "fordelene-ved-lgeautomater",
    "nl": "de-voordelen-van-vakjesautomaten"
  },
  "warenautomaten-fuer-non-food-artikel": {
    "da": "vareautomater-til-non-food-artikler",
    "nl": "verkoopautomaten-voor-non-food-artikelen"
  },
  "brauche-ich-fuer-meinen-verkaufsautomaten-eine-genehmigung": {
    "da": "har-jeg-brug-for-en-tilladelse-til-min-salgsautomat",
    "nl": "heb-ik-een-vergunning-nodig-voor-mijn-verkoopautomaat"
  },
  "eier-aus-dem-automaten": {
    "da": "g-fra-automaten",
    "nl": "eieren-uit-de-automaat"
  },
  "einen-verkaufsautomaten-leasen": {
    "da": "lease-en-salgsautomat",
    "nl": "een-verkoopautomaat-leasen"
  },
  "ersatzteile-fuer-die-marktbox": {
    "da": "reservedele-til-marktbox",
    "nl": "reserveonderdelen-voor-de-marktbox"
  },
  "verkaufsautomaten-mieten-oder-kaufen-mietkaufen": {
    "da": "leje-eller-kbe-salgsautomater-lejekb",
    "nl": "verkoopautomaten-huren-of-kopen-huurkopen"
  },
  "zubehoer-fuer-verkaufsautomaten": {
    "da": "tilbehr-til-salgsautomater",
    "nl": "accessoires-voor-verkoopautomaten"
  },
  "verkaufsautomaten-vor-vandalismus-schuetzen": {
    "da": "beskyt-salgsautomater-mod-hrvrk",
    "nl": "verkoopautomaten-beschermen-tegen-vandalisme"
  }
};
